<template>
  <div class="wrapper overlay-sidebar">
    <div>hello world</div>
  </div>
</template>
<script>
export default {
  name: "hub",
  data() {
    var PERMITTED_DOMAIN = "https://openroads.admin.innovativetoll.com"; // Production
    var PERMITTED_ADMIN_DOMAIN = "https://admin.innovativetoll.com"; // Production
    window.addEventListener("message", function (event) {
      if (
        event.origin === PERMITTED_DOMAIN ||
        event.origin === PERMITTED_ADMIN_DOMAIN
      ) {
        // var msg = JSON.parse(event.data);
        var msg = event.data;
        var msgKey = Object.keys(msg)[0];
        // const value
        if (event.data) {
          if (msgKey === "contact") {
            localStorage.setItem(msgKey, event.data.contact);
            this.$store.dispatch("auth/employeelogin", event.data.contact);
          } else if (msgKey === "user") {
            localStorage.setItem(msgKey, event.data.user);
          } else if (msgKey === "hasAccess") {
            localStorage.setItem(msgKey, event.data.hasAccess);
          } else if (msgKey === "client_sub_dept") {
            localStorage.setItem(msgKey, event.data.client_sub_dept);
          } else if (msgKey === "client_dept") {
            localStorage.setItem(msgKey, event.data.client_dept);
          }
        } else {
          localStorage.removeItem("localstorage");
        }
      }
    });
    return {};
  },

  computed: {},

  methods: {},
  //   created() {
  //     this.filters = this.axiosParams
  // 		this.loaddata()
  //   },
};
</script>

<style type="text/css">
table {
  white-space: nowrap;
  width: 100% !important;
  padding: 1px;
  border-collapse: collapse !important;
}

th {
  background-color: #d2e8fa !important;
  color: #5a6268 !important;
}
</style>
